import { createUseStyles } from "react-jss";
import * as Mixins from "../../../theme/Mixins";

function getRelativeSize(originalSize, { TextFontSize, BaseFontSize }) {
    return (TextFontSize * originalSize) / BaseFontSize;
}

export default createUseStyles({
    fileUploadContainer: {
        composes: "file-upload__container",
        height: ({ theme }) => getRelativeSize(256, theme),
        border: ({ theme }) => [[3, "dashed", theme.ControlBorderColor]],
        borderRadius: ({ theme }) => Math.min(theme.BorderRadius, getRelativeSize(256, theme) / 2),
        marginTop: ({ theme }) => Mixins.getSpacing(theme, 0, theme.QuestionSpacing?.WithinComponents),
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
    },
    fileUploadContainerDrag: {
        composes: "file-upload__container--drag",
        border: ({ theme }) => [[3, "dashed", theme.PrimaryColor]],
    },
    fileUploadIcon: {
        composes: "file-upload__icon",
        color: ({ theme }) => theme.PrimaryColor,
        margin: [[0, "auto"]],
    },
    fileUploadOptionText: {
        composes: "file-upload__upload-option-text",
        fontWeight: "bolder",
        margin: [[25, 0]],
    },
    fileUploadButton: {
        "&:hover": {
            background: ({ theme }) =>
                Mixins.darken(theme.PrimaryColor, theme.ActiveHighlightValue),
        },
        background: ({ theme }) => theme.PrimaryColor,
        borderRadius: ({ theme }) => theme.BorderRadius,
        color: ({ theme }) => Mixins.foregroundColor(theme, theme.PrimaryColor),
        composes: "file-upload__button",
        cursor: "pointer",
        fontSize: ({ theme }) => getRelativeSize(15, theme),
        fontWeight: 700,
        padding: [[10, 40]],
        transition: [["background", "200ms", "ease"]],
    },
    fileUploadSelectedFile: {
        background: ({ theme }) => Mixins.alpha(theme.ControlBackground, theme.ControlAlpha),
        borderRadius: ({ theme }) => Math.min(theme.BorderRadius, theme.ChoiceHeight / 2),
        boxShadow: ({ theme }) => `0 0 0 ${theme.BorderWidth}px ${theme.ControlBorderColor} inset`,
        composes: "file-upload__selected-file",
        marginTop: 26,
        overflow: "hidden",
        position: "relative",
    },
    fileUploadFileInfo: {
        composes: "file-upload__file-info",
        height: ({ theme }) => theme.ChoiceHeight,
        position: "relative",
        padding: [[0, 26]],
        display: "flex",
    },
    fileUploadFileContainer: {
        composes: "file-upload__file-container",
        flexGrow: 1,
        minWidth: 0,
    },
    fileUploadFileContainerInner: {
        display: "inline-flex",
        minWidth: 0,
        maxWidth: "100%",
        cursor: "pointer",
        transition: "color 200ms ease",
        outline: "none",
    },
    fileUploadFileIcon: {
        composes: "file-upload__file-icon",
        display: "inline-block",
        fontSize: 40,
        lineHeight: ({ theme }) => `${theme.ChoiceHeight}px`,
        marginRight: 20,
        "& img": {
            borderRadius: 3,
            height: 38,
            objectFit: "cover",
            paddingTop: 10,
            width: 38,
        },
    },
    fileUploadFileDetails: {
        composes: "file-upload__file-details",
        paddingTop: 10,
        fontSize: ({ theme }) => getRelativeSize(15, theme),
        lineHeight: "20px",
        display: "inline-block",
        minWidth: 0,
    },
    fileUploadFileName: {
        composes: "file-upload__file-name",
        fontWeight: "bolder",
        textOverflow: "ellipsis",
        overflowX: "hidden",
        whiteSpace: "nowrap",
    },
    fileUploadFileSize: {
        composes: "file-upload__file-size",
    },
    fileUploadProgress: {
        background: ({ theme }) => theme.SecondaryColor,
        composes: "file-upload__progress",
        height: ({ theme }) => theme.ChoiceHeight,
        opacity: 0.15,
        position: "absolute",
        transition: "width 200ms ease 0s",
        zIndex: 2,
    },
    fileUploadProgressText: {
        composes: "file-upload__progress-text",
        flexShrink: 0,
        fontSize: 15,
        fontWeight: "bolder",
        height: "50%",
        margin: [["auto", 30]],
    },
    fileUploadValidationError: {
        color: ({ theme }) => theme.ErrorColor,
        composes: "file-upload__validation-error",
        extend: "fileUploadProgressText",
        fontWeight: "lighter",
    },
    fileUploadValidationErrorIcon: {
        composes: "validation-error__icon",
        marginRight: 10,
    },
    fileUploadDeleteButton: {
        composes: "file-upload__delete-button",
        height: "50%",
        margin: [["auto", 0]],
        color: ({ theme }) => theme.SecondaryColor,
        cursor: "pointer",
        "&:hover": {
            color: ({ theme }) => Mixins.darken(theme.SecondaryColor, theme.ActiveHighlightValue),
        },
        "&:focus-visible": {
            color: ({ theme }) => theme.PrimaryColor,
        },
        outline: "none",
    },
});
